export enum errorFraudMsg {
  es = "No tienes disponible esta promoción. Serás redirigido a nuestro sitio.",
  en = "You don't have this promotion available. You will be redirected to our site.",
  pt = "Você não tem esta promoção disponível. Você será redirecionado para o nosso site."
}
